import React, { useState } from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { SiteTitle } from '../SiteTitle';
import { loginInfo } from "../globalFunction/global_string";
import HistoryTenTrackingList from "../TenableHooK/HistoryTenTrackingList";


function History_Track_Background() {
    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <SiteTitle />
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="tracking tabs"
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "blue",
                            }
                        }}
                    >
                        <Tab label="查看主機歷史紀錄" value="1" />
                    </Tabs>
                </Box>
                <TabPanel value="1">
                    <HistoryTenTrackingList />
                </TabPanel>
            </TabContext>
        </div>
    );
}

export default History_Track_Background;
